export default __webpack_public_path__ + "static/media/activity.e7a12e5f.svg";